var map = {
	"./app_strings.json": 52507,
	"./client/account_client.json": 86937,
	"./client/common_client.json": 80055,
	"./client/console.json": 66619,
	"./client/consultation_client.json": 43061,
	"./client/eyes.json": 55576,
	"./client/nav_client.json": 18858,
	"./client/patient_client.json": 94552,
	"./client/pdf.json": 56612,
	"./client/stats_client.json": 72113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86013;